const DEFAULT_BROWSER_LOCALE = 'en';
const DEFAULT_NORMALIZED_BROWSER_LOCALE = 'en-GB';
class Browser {
  static getBrowserLocale() {
    if (typeof navigator === 'undefined') {
      return DEFAULT_BROWSER_LOCALE;
    }
    if (navigator.languages && navigator.languages.length) {
      // latest versions of Chrome and Firefox set this correctly
      return navigator.languages[0];
    } else if (navigator.userLanguage) {
      // IE only
      return navigator.userLanguage;
    } else {
      // latest versions of Chrome, Firefox, and Safari set this correctly
      return navigator.language || DEFAULT_BROWSER_LOCALE;
    }
  }
  static getNormalizedLocale(locale, supportedLocales) {
    const [language] = locale.split('-');
    if (!supportedLocales) {
      return locale;
    }
    const supportedLanguages = supportedLocales.map(supportedLocale => supportedLocale.split('-')[0]);
    const supportedLanguagesIndex = supportedLanguages.indexOf(language);
    if (supportedLanguagesIndex === -1) {
      return DEFAULT_NORMALIZED_BROWSER_LOCALE;
    }
    if (supportedLocales.indexOf(locale) > -1) {
      return locale;
    }
    return supportedLocales[supportedLanguagesIndex];
  }
  static getNormalizedBrowserLocale(supportedLocales) {
    return Browser.getNormalizedLocale(Browser.getBrowserLocale(), supportedLocales);
  }
}

export { Browser, DEFAULT_BROWSER_LOCALE, DEFAULT_NORMALIZED_BROWSER_LOCALE };
//# sourceMappingURL=Browser.js.map
